
import { useState } from 'react';
import { tips } from '../../../mocks/tips';

const categories = ['All', ...Array.from(new Set(tips.map((t) => t.category)))];

export default function TipsAndTricks() {
  const [activeCategory, setActiveCategory] = useState('All');
  const [hoveredId, setHoveredId] = useState<number | null>(null);

  const filtered =
    activeCategory === 'All' ? tips : tips.filter((t) => t.category === activeCategory);

  return (
    <section id="tips" className="bg-[#0d0d0d] py-24 px-6">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="text-[#8B0000] text-sm font-bold tracking-widest uppercase">
            Learn From The Nightmare
          </span>
          <h2 className="text-5xl font-bold text-white mt-3 mb-4">TIPS &amp; TRICKS</h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto">
            Master your game with insights from a professional pitcher
          </p>
        </div>

        {/* Category Tabs */}
        <div className="flex items-center justify-center gap-2 mb-12 flex-wrap">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`px-5 py-2 rounded-full text-sm font-semibold tracking-wide transition-all duration-300 cursor-pointer whitespace-nowrap ${
                activeCategory === cat
                  ? 'bg-[#8B0000] text-white'
                  : 'bg-[#1a1a1a] text-gray-500 hover:text-gray-300 hover:bg-[#222]'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Tips List */}
        <div className="space-y-4">
          {filtered.map((tip) => {
            const globalIndex = tips.findIndex((t) => t.id === tip.id);
            const isHovered = hoveredId === tip.id;

            return (
              <div
                key={tip.id}
                onMouseEnter={() => setHoveredId(tip.id)}
                onMouseLeave={() => setHoveredId(null)}
                className={`flex items-center gap-6 bg-[#141414] rounded-lg px-8 py-6 border transition-all duration-300 cursor-pointer ${
                  isHovered
                    ? 'border-[#8B0000]/40 shadow-lg shadow-red-950/10 -translate-y-0.5'
                    : 'border-gray-800/60'
                }`}
              >
                {/* Number */}
                <span
                  className={`text-3xl font-black min-w-[48px] text-center transition-colors duration-300 ${
                    isHovered ? 'text-[#8B0000]' : 'text-gray-800'
                  }`}
                >
                  {String(globalIndex + 1).padStart(2, '0')}
                </span>

                {/* Icon */}
                <div
                  className={`w-12 h-12 flex items-center justify-center rounded-lg shrink-0 transition-colors duration-300 ${
                    isHovered ? 'bg-[#8B0000]/20' : 'bg-[#8B0000]/10'
                  }`}
                >
                  <i className={`${tip.icon} text-xl text-[#8B0000]`}></i>
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0">
                  <h3 className="text-white text-lg font-bold mb-1">{tip.title}</h3>
                  <p className="text-gray-500 text-sm leading-relaxed line-clamp-2">
                    {tip.description}
                  </p>
                </div>

                {/* Category + Arrow */}
                <div className="flex items-center gap-4 shrink-0">
                  <span className="text-gray-600 text-xs font-semibold uppercase tracking-wider bg-[#1a1a1a] px-3 py-1 rounded">
                    {tip.category}
                  </span>
                  <i
                    className={`ri-arrow-right-line text-lg transition-all duration-300 ${
                      isHovered ? 'text-[#8B0000] translate-x-1' : 'text-gray-700'
                    }`}
                  ></i>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="mt-16 text-center bg-[#141414] rounded-lg p-10 border border-gray-800">
          <h3 className="text-3xl font-bold text-white mb-3">
            Want More Exclusive Training Content?
          </h3>
          <p className="text-gray-500 mb-8 max-w-lg mx-auto">
            Subscribe for advanced pitching techniques, workouts, and behind-the-scenes content.
          </p>
          <div className="flex items-center justify-center gap-3 max-w-md mx-auto">
            <input
              type="email"
              placeholder="Enter your email"
              className="flex-1 bg-[#0d0d0d] text-white text-sm px-5 py-3.5 rounded border border-gray-800 focus:border-[#8B0000] focus:outline-none transition-colors"
            />
            <button className="bg-[#8B0000] hover:bg-[#6B0000] text-white font-semibold text-sm px-6 py-3.5 rounded transition-all duration-300 whitespace-nowrap cursor-pointer">
              SUBSCRIBE
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
